var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4359_5471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 20.3125C4.32168 20.3125 0.266992 13.1828 0.0984375 12.8795C-0.0328125 12.6434 -0.0328125 12.3564 0.0984375 12.1203C0.266992 11.8172 4.32168 4.6875 12.5 4.6875C20.6783 4.6875 24.733 11.8172 24.9016 12.1205C25.0328 12.3566 25.0328 12.6436 24.9016 12.8797C24.733 13.1828 20.6783 20.3125 12.5 20.3125ZM1.70059 12.4988C2.62988 13.9072 6.27852 18.75 12.5 18.75C18.7412 18.75 22.3736 13.9111 23.2994 12.5012C22.3701 11.0928 18.7215 6.25 12.5 6.25C6.25879 6.25 2.62637 11.0889 1.70059 12.4988ZM12.5 17.1875C9.91523 17.1875 7.8125 15.0848 7.8125 12.5C7.8125 9.91523 9.91523 7.8125 12.5 7.8125C15.0848 7.8125 17.1875 9.91523 17.1875 12.5C17.1875 15.0848 15.0848 17.1875 12.5 17.1875ZM12.5 9.375C10.777 9.375 9.375 10.777 9.375 12.5C9.375 14.223 10.777 15.625 12.5 15.625C14.223 15.625 15.625 14.223 15.625 12.5C15.625 10.777 14.223 9.375 12.5 9.375Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4359_5471"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordEye);
export default __webpack_public_path__ + "static/media/password_eye.ca73e0b9ff1071f8cbcf786d5533e29e.svg";
export { ForwardRef as ReactComponent };